import React from 'react';
import { connect } from 'react-redux';
import * as BS from 'reactstrap';
import { saveModel } from '../actions';

const SignupModel = (props) => {

    if (props.status == 1) {
        return <section className="form">
            <div className="container container-md">

                <div className="row align-items-center">
                    <div className="col align-self-center">
                        <div className="form-header">
                            <div className="text-center">
                                <img src="http://linkin.se/images/logo.svg" alt="Linkin logotyp" width="120"/>
                                <h1>Modellregistrering</h1>
                                <div className="form-text text-muted">Genom att registrera dig som modell i vår databas ökar du din synlighet för framtida uppdrag. Dessutom förenklas administrationen och avtalsskrivandet inför dina fotograferingar.</div>
                                <div className="alert alert-success text-center">
                                    Klart! Du är nu registrerad i vår databas och sökbar för kommande uppdrag.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>;
    }

    return <section className="form">
        <div className="container container-md">
            <div className="row align-items-center">
                <div className="col align-self-center">
                    <div className="form-header">
                        <div className="text-center">
                            <img src="http://linkin.se/images/logo.svg" alt="Linkin logotyp" width="120"/>
                            <h1>Modellregistrering</h1>
                            <div className="form-text text-muted">Genom att registrera dig som modell i vår databas ökar du din synlighet för framtida uppdrag. Dessutom förenklas administrationen och avtalsskrivandet inför dina fotograferingar.</div>
                        </div>
                    </div>
                    <form>
                        <div className="form-group">
                            <label>Profilbild</label>
                            {!props.image && <div className="form-control">
                                <hr />
                                <label htmlFor={ 'profile-register' } className="profile-pick btn btn-success">Välj eller ta en bild</label>
                                <input id={ 'profile-register' } type="file" name={ 'profile-register' } className="profile-pick-file"  onChange={props.onPhoto.bind(null)} />
                            </div>}
                            {props.image && <div className="form-control"><img src={props.image} style={ { width: '100%' } } />
                                <hr />
                                <button onClick={props.newProfile.bind(null)} className="btn btn-success">Byt bild</button>
                            </div> }
                        </div>
                        <div className="form-group">
                            <label>Personnummer</label>
                            <input type="text" className="form-control" onChange={props.onFieldChange.bind(null, 'ssn')}
                                   value={ props.ssn }/>
                        </div>
                        <div className="form-group">
                            <label>Namn</label>
                            <input type="text" className="form-control" onChange={props.onFieldChange.bind(null, 'name')}
                                   value={ props.name }/>
                        </div>
                        <div className="form-group">
                            <label>Gatuadress</label>
                            <input type="text" className="form-control" onChange={props.onFieldChange.bind(null, 'address')}
                                   value={ props.address }/>
                        </div>
                        <div className="form-row">
                            <div className="col-3">
                                <div className="form-group">
                                    <label>Postnummer</label>
                                    <input type="text" className="form-control" onChange={props.onFieldChange.bind(null, 'postal_code')}
                                           value={ props.postal_code }/>
                                </div>
                            </div>
                            <div className="col-9">
                                <div className="form-group">
                                    <label>Postort</label>
                                    <input type="text" className="form-control" onChange={props.onFieldChange.bind(null, 'city')}
                                           value={ props.city }/>
                                </div>
                            </div>
                        </div>
                        <div className="form-group">
                            <label>E-post</label>
                            <input type="text" className="form-control" onChange={props.onFieldChange.bind(null, 'email')}
                                   value={ props.email }/>
                        </div>
                        <div className="form-group">
                            <label>Telefon</label>
                            <input type="text" className="form-control" onChange={props.onFieldChange.bind(null, 'phone')}
                                   value={ props.phone }/>
                        </div>
                        <div className="form-group">
                            <label>Beskrivning om dig</label>
                            <textarea className="form-control" onChange={props.onFieldChange.bind(null, 'description')}
                                      rows="3">{ props.description }</textarea>
                        </div>
                        <div className="form-group">
                            <div className="form-control form-control-terms">
                                <h3>Användarvillkor & Integritet</h3>
                                <p>När du registrerar dig själv eller registrerar en annan person (exempelvis ditt barn) sparar vi de personuppgifter som behövs för att kunna erbjuda modelluppdrag, hantera avtal samt genomföra utbetalningar. Vi behandlar endast nödvändiga uppgifter såsom kontaktuppgifter, personnummer, kontouppgifter samt bilder och material som laddas upp.</p>
                                <p>Om du registrerar en annan person intygar du att du har rätt att företräda personen och lämna samtycke till behandlingen av dennes personuppgifter.</p>
                                <p>Behandlingen sker för att uppfylla vårt avtal med dig och/eller den registrerade personen, med stöd av samtycke samt för att följa lagkrav, exempelvis bokföringslagen där vissa uppgifter måste sparas i minst sju år.</p>
                                <p>Personuppgifter delas endast med parter som behöver dem för att kunna genomföra uppdrag eller betalningar och lämnas aldrig vidare i marknadsföringssyfte.</p>
                                <p>Du kan när som helst avsluta kontot. Uppgifter kopplade till kontot sparas så länge det är aktivt. Avtal och uppgifter som omfattas av lagkrav sparas under sin giltighetstid och enligt lagstadgade regler. Du har rätt att begära registerutdrag, rättning eller radering av personuppgifter.</p>
                                <p>För frågor eller önskemål gällande personuppgifter, kontakta oss på info@linkin.se.</p>

                                <div className="switch-container">
                                    <button onClick={props.onTerms} className={"switch" + (props.terms ? " checked" : "")}>
                                        <span className="slider"></span>
                                        <span className="label">Jag godkänner villkoren</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                        {props.invalid && props.invalidStatus === 400 && <div className="alert alert-warning">
                            Var vänlig och kontrollera att följande fält är korrekt ifyllda:
                            <ul className="list-unstyled">
                                {props.invalidData && props.invalidData.map(data => {
                                    let text = null;
                                    switch (data) {
                                        case 'terms':
                                            text = 'Det krävs att du godkänner användarvillkoren'
                                            break;
                                        case 'ssn':
                                            text = 'Personnummer: Ange ett giltigt och fullständigt personnummer (ÅÅÅÅMMDD-XXXX).'
                                            break;
                                        case 'name':
                                            text = 'Namn: Ange ett namn'
                                            break;
                                        case 'phone':
                                            text = 'Telefon: Ange ett telefonnummer utan mellanslag'
                                            break;
                                        case 'email':
                                            text = 'Epost: Ange en giltig epostadress'
                                            break;
                                        case 'address':
                                            text = 'Adress: Ange en adress'
                                            break;
                                        case 'postal_code':
                                            text = 'Postnummer: Ange fem siffror utan mellanslag'
                                            break;
                                        case 'city':
                                            text = 'Postort: Ange en postort'
                                            break;
                                        case 'location':
                                            text = 'Plats: Ange plats (vid undertecknandet)'
                                            break;
                                        case 'signature':
                                            text = 'Signatur: Teckna din signatur'
                                            break;
                                        case 'payment':
                                            text = 'Betalning: Ange din kompletta betalningsinformation'
                                            break;
                                        case 'image':
                                            text = 'Bild: Ogiltig profilbild, välj en ny bild'
                                            break;

                                    }
                                    if (text) {
                                        return <li>{text}</li>
                                    }
                                })}
                            </ul>
                        </div>}
                        {props.invalidStatus === 409 && <div className="alert alert-warning">
                            Du är redan registrerad. <a href="/profil">Klicka här</a> för att logga in
                        </div>}
                        {props.invalidUnknown && <div className="alert alert-danger">
                            Ett oväntat fel uppstod, om problemet kvarstår var vänlig och kontakta oss. (Felkod: {props.errorCode})
                        </div>}
                        <div className="form-footer text-center">
                            <button type="submit" className="btn btn-success btn-lg" disabled={!props.terms} onClick={props.onSaveModel}>
                                Skicka <i className="fa-light fa-arrow-right"></i></button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </section>
}

export default connect(store => store.registerModelState, (dispatch) => {
    return {
        onFieldChange: (field, e) => {
            dispatch({
                type: 'REGISTER_MODEL_FIELD_CHANGE',
                field: field,
                value: e.target.value
            })
        },
        newProfile: (e) => {
            dispatch({
                type: 'REGISTER_MODEL_FIELD_CHANGE',
                field: 'image',
                value: ''
            })
        },
        onTerms: (e) => {
            e.preventDefault();
            dispatch({
                type: 'REGISTER_MODEL_TERMS'
            })
        },
        onSaveModel: (e) => {
            e.preventDefault();
            saveModel(dispatch);
        },
        onPhoto: ( e) => {
            var file = e.target.files[0];
            var reader = new FileReader();
            reader.onloadend = function() {
                var orgImage = new Image;
                orgImage.onload = () => {
                    // create an off-screen canvas
                    var canvas = document.createElement('canvas'),
                        ctx = canvas.getContext('2d');

                    var maxWidth = 600;
                    var maxHeight = 600;

                    var ratio = maxWidth / orgImage.width;
                    var newW = maxWidth;
                    var newH = orgImage.height * ratio;

                    if (newH > maxHeight) {
                        ratio = maxHeight / orgImage.height;
                        newH = maxHeight;
                        newW = orgImage.width * ratio;
                    }

                    // set its dimension to target size
                    canvas.width = newW;
                    canvas.height = newH;

                    // draw source image into the off-screen canvas:
                    ctx.drawImage(orgImage, 0, 0, newW, newH);

                    // encode image to data-uri with base64 version of compressed image
                    var image = canvas.toDataURL('image/jpeg', 0.8);

                    dispatch({
                        type: 'REGISTER_MODEL_FIELD_CHANGE',
                        field: 'image',
                        value: image
                    })
                };
                orgImage.src = reader.result;


            }
            reader.readAsDataURL(file);
        }
    }
})(SignupModel);

